import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { RbacButton } from 'components/organisms/rbac/components/rbac-buttons';
import {
  Caption01,
  ProductiveHeading05,
  ProductiveHeading07,
  SingleLineEllipsis,
} from 'components/styles';

export const SelectContainer = styled.div`
  height: 472px;
  width: 336px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Empty = styled.div`
  ${Caption01};
  position: absolute;
  bottom: var(--spacing-05);
  left: var(--spacing-03);
  color: var(--gray-70);
  padding: 0 var(--spacing-05);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > svg {
    height: 80px;
    margin-bottom: var(--spacing-05);
  }
  ${Button} {
    padding-left: 0;
    padding-right: 0;
    margin-top: var(--spacing-03);
  }
`;

export const RoundedCheckbox = styled(Checkbox)`
  margin-right: var(--spacing-03);
  margin-bottom: var(--spacing-02);

  .ant-checkbox-inner {
    border-radius: 50%;
  }
  .ant-checkbox:hover::after {
    border-radius: 50%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: var(--spacing-05);
  margin: var(--spacing-05);

  ${Button} {
    flex: 1;
    height: 32px;
  }
`;

export const PickerHeader = styled.div`
  ${ProductiveHeading07};
  margin: var(--spacing-05) var(--spacing-05) 0;
`;

export const OptionWrapper = styled.div`
  height: var(--spacing-06);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TaskNameWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const AddButton = styled(RbacButton)`
  padding: 0 var(--spacing-05);
`;

export const NoSearchTitle = styled.div`
  ${ProductiveHeading05};
  margin-bottom: var(--spacing-05);
`;

export const NoOptionsWrapper = styled.div`
  height: 300px;
`;

export const Ellipsis = styled.div`
  ${SingleLineEllipsis};
  width: 250px;
`;

export const Spacer = styled.div`
  text-align: left;
  margin-bottom: var(--spacing-06);
`;
